import { theme } from "@tm/utility/global";
import { OrderDetailV2Hero } from "../../OrderDetailV2/components/OrderDetailV2Hero";
import { useCancelPolicyStatic } from "../CancelPolicyContext";
import type { CancelPolicyApiHeader } from "../types";

interface CancelPolicyDesktopPageHeaderProps {
  header?: CancelPolicyApiHeader;
}

export const CancelPolicyDesktopPageHeader = ({
  header,
}: CancelPolicyDesktopPageHeaderProps) => {
  const { bookingId, showNav } = useCancelPolicyStatic();

  return (
    <OrderDetailV2Hero
      bookingId={bookingId}
      title={header?.title}
      orderIdLabel={header?.subTitle}
      backgroundImage={header?.style?.backgroundImage}
      bgColor={header?.style?.backgroundColor ?? theme.lightRed}
      showNav={showNav}
    />
  );
};

export default CancelPolicyDesktopPageHeader;
